<template>
  <div class="app-action-box">
    <el-button :aria-label="title"
               :icon="icon"
               @click="toggleDialog"
               circle
               class="hidden-md-and-up"
               role="button">
    </el-button>

    <el-dialog :fullscreen="true"
               :title="title"
               :visible.sync="isDialogOpened">
      <el-form label-position="top">
        <slot></slot>
      </el-form>
      <span slot="footer">
          <el-button @click="toggleDialog"
                     round>
            {{ $t('ACTIONS.CANCEL') }}
          </el-button>
          <el-button @click="emit"
                     round
                     type="primary">
            {{ $t('ACTIONS.APPLY') }}
          </el-button>
        </span>
    </el-dialog>

    <el-form @submit.native.prevent="emit"
             label-position="top">
      <el-card class="hidden-sm-and-down"
               shadow="never">
        <div slot="header">
          <span>{{ title }}</span>
          <el-button native-type="submit"
                     round
                     style="float: right; padding: 3px 0"
                     type="text">
            {{ $t('ACTIONS.APPLY') }}
          </el-button>
        </div>
        <slot></slot>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'AppActionBox',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isDialogOpened: false
    }
  },
  methods: {
    toggleDialog () {
      this.isDialogOpened = !this.isDialogOpened
    },
    emit () {
      this.isDialogOpened = false
      this.$emit('submit')
    }
  }
}
</script>
